'user strict'
const ex = require('../lib/error')
const Sequelize = require('../config/db')
const masterItems = require('../models').masterItems
const measurements = require('../models').measurements
const {masterItem} = require('../repository/index')
const sequelize = require('sequelize')
const Op = sequelize.Op

const createMasterIteminBulk = (req, res, next) => {
  req.body.items.map(item => {
    if(item.id < 0){
      item.id = null;
    }
  })
  masterItems.bulkCreate(req.body.items, { returning: true })
    .then(items => {
      req.responseObject.data.items = items
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'MAUD006'
      ex.raiseError(req, res, errCode, 500, error)
    });


}
const getMasterItemsByNames = (req, res, next) => {
  let limit = 10
  let offset = (req.params.page + 1) * limit - limit
  masterItem.getListItem(req.body.userId, req.body.name, offset)
  .then(items =>{
    req.responseObject.messageCode = 'OVA005'
    req.responseObject.data = items[0]
    next()
  }).catch(error => {
    let errCode
    errCode = 'OVA006'
    ex.raiseError(req, res, errCode, 500, error)
  })
}
const addInvoiceIdtoItems = (req, res, next) => {
  let reqBody = JSON.parse(JSON.stringify(req.body))
  if(reqBody.items) {
    reqBody.items.forEach(items => {
      items.invoiceid = req.responseObject.data.invoice.id
      items.userId = req.responseObject.data.invoice.userid
      if(items.id === -1) {
        delete items.id;
      }
    });
  }
  req.body = reqBody
  next()
}
const updateMasterItems = (req, res, next) => {
  if (req.body.items != null && req.body.items.length > 0) {
    req.body.items.map(item => {
      if(item.id < 0){
        item.id = null;
      }
    })
    masterItems.update(
      { is_active: false }, {
      where: { invoiceid: req.params.id }
    }).then(items => {

      masterItems.bulkCreate(req.body.items, {
        updateOnDuplicate: ["id", "name", "quantity", "gstAmount", "totalAmount", "is_active"]
      })
        .then(items => {
          req.responseObject.data.items = items
          next()
        })
        .catch(error => {
          let errCode
          errCode = 'MAUD0061'
          ex.raiseError(req, res, errCode, 500, error)
        });
    })
      .catch(error => {
        let errCode
        errCode = 'MAUD0061'
        ex.raiseError(req, res, errCode, 500, error)
      });

  } else {
    next()
  }

}
module.exports = {
  createMasterIteminBulk,
  getMasterItemsByNames,
  addInvoiceIdtoItems,
  updateMasterItems,
}
